import styled from "styled-components";

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const NotificationIcon = styled.div`
  position: relative;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  img {
    width: 24px;
    height: 24px;
    filter: invert(1);
  }
  ${(props) =>
    props.hasUnread &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 6px;
      right: 6px;
      width: 8px;
      height: 8px;
      background-color: #7ce009ff;
      border-radius: 50%;
      border: 2px solid #2c3e50;
    }
  `}
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  min-width: 300px;
  max-width: 400px;
  max-height: 500px;
  overflow-y: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin: 8px 0 0 0;
  padding: 0;
  list-style: none;
  z-index: 1000;
  border: 1px solid #e0e0e0;
`;

export const ChangeItem = styled.li`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: #f8f9fa;
  }
`;

export const ChangeDate = styled.div`
  font-size: 12px;
  color: #666;
  font-weight: 600;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ChangeText = styled.div`
  font-size: 14px;
  color: #333;
  line-height: 1.4;
`;

export const DropdownHeader = styled.div`
  padding: 16px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 600;
  color: #333;
  font-size: 16px;
  border-radius: 8px 8px 0 0;
`;

export const EmptyState = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: #666;
  font-size: 14px;
`;